(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zp-v29-upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-zp-up-form]')) return;
    event.preventDefault();
    var btn = form.querySelector('[data-zp-up-btn]');
    if (!btn || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ajout…';
    fetch(form.action + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (res) { if (!res.ok) throw new Error('add'); return res.json(); })
      .then(function () { btn.textContent = 'Ajouté ✓'; })
      .catch(function () { btn.disabled = false; btn.textContent = label; form.submit(); });
  });
  } catch(e) { console.error(e); }
})();

})();
